import React from "react";
import "./Card.css";
import Img from "./1.png";
import Img2 from "./2.jpg";
import Img3 from "./3.png";
import { Link } from "react-router-dom";
const Card = () => {
  return (
    <div className="multiple-card">
      <Link to="/okrs">
        <div className="card">
          <div classname="card-image">
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={Img2}
              alt="pic"
            />
          </div>
          <div
            classname="card-title"
            style={{
              fontSize: "25px",
              padding: "10px",
              color: "black",
              height: "65px",
            }}
          >
            OKR Cheat Sheet
          </div>
          <div
            classname="card-description"
            style={{
              display: "flex",
              fontSize: "15px",
              height: "120px",
              alignItems: "center",
              justifyContent: "center",
              color: "#696969",
              textAlign: "left",
              padding: "15px",
            }}
          >
            Having trouble setting OKRs for your team and don't know where to
            start? We've compiled a department and function wise break down for
            you!
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              fontSize: "15px",
              alignItems: "center",
              color: "black",
              textAlign: "left",
              paddingLeft: "15px",
              paddingBottom: "15px",
            }}
          >
            <b>Try Now ></b>
          </div>
        </div>
      </Link>

      <Link to="/quiz">
        <div className="card">
          <div classname="card-image">
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={Img3}
              alt="pic"
            />
          </div>
          <div
            classname="card-title"
            style={{
              fontSize: "20px",
              padding: "10px",
              color: "black",
              height: "65px",
            }}
          >
            Performance Management Healthcheck
          </div>
          <div
            classname="card-description"
            style={{
              display: "flex",
              fontSize: "15px",
              height: "120px",
              alignItems: "center",
              justifyContent: "center",
              color: "#696969",
              textAlign: "left",
              padding: "15px",
            }}
          >
            Want to find out how effective your company’s performance management
            style is and how yours stacks compared to others?
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              fontSize: "15px",
              alignItems: "center",
              color: "black",
              textAlign: "left",
              paddingLeft: "15px",
              paddingBottom: "15px",
            }}
          >
            <b>Try Now ></b>
          </div>
        </div>
      </Link>

      <Link to="/core-value-creator">
        <div className="card">
          <div classname="card-image">
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={Img}
              alt="pic"
            />
          </div>
          <div
            classname="card-title"
            style={{
              fontSize: "25px",
              padding: "10px",
              color: "black",
              height: "65px",
            }}
          >
            Core Values Creator
          </div>
          <div
            classname="card-description"
            style={{
              display: "flex",
              fontSize: "15px",
              height: "120px",
              alignItems: "center",
              color: "#696969",
              textAlign: "left",
              padding: "15px",
            }}
          >
            Mesh's core value creator makes it easy for your to identify core
            values basis your beliefs and attitudes. Give it a try today!
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              fontSize: "15px",
              alignItems: "center",
              color: "black",
              textAlign: "left",
              paddingLeft: "15px",
              paddingBottom: "15px",
            }}
          >
            <b> Try Now ></b>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Card;
